"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFallback = exports.NoImage = exports.NoProductImage = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
exports.NoProductImage = "/static/media/no-product-image.png";
exports.NoImage = "/static/media/no-image.png";
const ImageFallback = (_a) => {
    var { fallback = "no-image", src } = _a, imgProps = __rest(_a, ["fallback", "src"]);
    const initialSrc = src && src.trim() ? src : getNoImageUrl(fallback);
    const [imgUrl, setImgUrl] = (0, react_1.useState)(() => initialSrc);
    (0, react_1.useEffect)(() => {
        const newSrc = src && src.trim() ? src : getNoImageUrl(fallback);
        setImgUrl(newSrc);
    }, [src, fallback]);
    const handleError = () => {
        setImgUrl(getNoImageUrl(fallback));
    };
    // @ts-ignore
    // eslint-disable-next-line jsx-a11y/alt-text
    return (0, jsx_runtime_1.jsx)("img", Object.assign({}, imgProps, { src: imgUrl, onError: handleError }));
};
exports.ImageFallback = ImageFallback;
const getNoImageUrl = (v) => {
    switch (v) {
        case "no-product":
            return exports.NoProductImage;
        default:
            return exports.NoImage;
    }
};
